import React from "react";
import { useMediaQuery } from "react-responsive";
import DesktopMakeModelYearForm from "./DesktopMakeModelYearForm";
import TabletMakeModelYearForm from "./TabletMakeModelYearForm";
import useSystemHook from "../../hooks/SystemHook";
import MobileMakeModelYearForm from "./MobileMakeModelYearForm";

const MakeModelYearForm = ({
                               makeOptions,
  handleUserVehicleChange,
  loading,
  variantOptions,
  yearOptions,
  modelOptions,
  userInput,
  setUserInput,
  submit,
  inputsPerRowMobile = 2,
  inputsPerRowDesktop = 4,
  darkMode,
  showHeader,
  onReset,
}) => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  // Handle reset by clearing userInput to default state
  const handleReset = () => {
    setUserInput({
      make: null,
      model: null,
      variant: null,
      year: null,
    });
  };

  return isTablet ? (
    <TabletMakeModelYearForm
        makeOptions={makeOptions}
      handleUserVehicleChange={handleUserVehicleChange}
      loading={loading}
      variantOptions={variantOptions}
      yearOptions={yearOptions}
      modelOptions={modelOptions}
      userInput={userInput}
      setUserInput={setUserInput}
      submit={submit}
      inputsPerRowMobile={inputsPerRowMobile}
      darkMode={darkMode}
      handleReset={handleReset}
      showHeader={showHeader}
    />
  ) : isMobile ? (
    <MobileMakeModelYearForm
        makeOptions={makeOptions}
      handleUserVehicleChange={handleUserVehicleChange}
      loading={loading}
      variantOptions={variantOptions}
      yearOptions={yearOptions}
      modelOptions={modelOptions}
      userInput={userInput}
      setUserInput={setUserInput}
      submit={submit}
      inputsPerRowMobile={inputsPerRowMobile}
      darkMode={darkMode}
      handleReset={handleReset}
      showHeader={showHeader}
    />
  ) : (
    <DesktopMakeModelYearForm
        makeOptions={makeOptions}
      handleUserVehicleChange={handleUserVehicleChange}
      loading={loading}
      variantOptions={variantOptions}
      yearOptions={yearOptions}
      modelOptions={modelOptions}
      userInput={userInput}
      setUserInput={setUserInput}
      submit={submit}
      inputsPerRowDesktop={inputsPerRowDesktop}
      darkMode={darkMode}
      handleReset={handleReset}
      showHeader={showHeader}
    />
  );
};

export default MakeModelYearForm;
